//import axios from "axios";

export const state = {
    apiKey: 'eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhZG1pbmlzdHJhdG9yIiwiaWF0IjoxNzQ4MDA0ODk2LCJleHAiOjE3NDgxMTI4OTYsImlzcyI6IkVaRUxJTksgVGVsZWNvbSBMTEMiLCJhdWQiOiJFWkVMSU5LIn0.sJQdtQAKVdsTHCrIkfh-vf3eJnDox0vXzjMogRqcvYA',
    apiHost: 'http://192.168.203.47:8080',
    apiOrgId: '1b0f79e17233c082'
};

export const getters = {
    apiKey: state => state.apiKey,
    apiHost: state => state.apiHost,
};

export const mutations = {
    setApiKey(state, newValue) {
        state.apiKey = newValue
    },
};

export const actions = {
    // fetchTodos({ commit }) {
    //     axios.get('https://jsonplaceholder.typicode.com/todos').then(res => {
    //         commit('setTodos', res.data)
    //     })
    // },
};
